/**
 * "How the map works" — the explainer window's slides.
 *
 * Wording rule (Janeks): precise, and understandable to players whose first
 * language is not English. So: short sentences, one idea each, the same word
 * for the same thing every time (a "run" is always a "run"), no idioms, no
 * slang, no contractions. Every claim here is checked against
 * design/gdd/world-map-locations.md and design/gdd/raid-expedition.md.
 */
export interface MapSlide {
  title: string;
  /** One short sentence per entry. */
  lines: string[];
  /** A word shown big on the slide's picture. */
  badge: string;
}

export const MAP_SLIDES: readonly MapSlide[] = [
  {
    title: 'The world map',
    badge: 'MAP',
    lines: [
      'The map shows the land outside your settlement.',
      'Press M in the settlement to open it.',
      'The land is split into regions.',
    ],
  },
  {
    title: 'Dark regions',
    badge: 'FOG',
    lines: [
      'A dark region is not explored yet.',
      'Do an Explore run to light it up.',
      'Explored regions show the places inside them.',
    ],
  },
  {
    title: 'Choose a goal',
    badge: 'GOAL',
    lines: [
      'First choose a region. Then choose a goal.',
      'Scavenge: look for items.',
      'Raid: fight for better loot.',
      'Bounty: hunt a target for a reward.',
      'Explore: show more of the map.',
    ],
  },
  {
    title: 'Danger and loot',
    badge: 'RISK',
    lines: [
      'Regions far from home have more danger.',
      'They also give better loot.',
      'Start with the regions near your settlement.',
    ],
  },
  {
    title: 'The run',
    badge: 'RUN',
    lines: [
      'A run costs energy. You pay it at the start.',
      'Your survivor walks the run alone, step by step.',
      'Daylight is limited. It gets darker with each step.',
      'Danger grows when it is dark.',
    ],
  },
  {
    title: 'Your bag',
    badge: 'BAG',
    lines: [
      'You can only carry what fits in your bag.',
      'When the bag is full, the run ends and you go home safely.',
      'Loot goes to your hideout only when you move it there.',
    ],
  },
  {
    title: 'Go home or lose it',
    badge: 'EXIT',
    lines: [
      'You can extract at any step. Extract means: go home with your loot.',
      'If you die, you lose everything in your bag.',
      'You keep the gear you are wearing.',
      'You wake up in the Med-Center.',
    ],
  },
];
